import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandTake_5Page } from './cabsand-take-5';

@NgModule({
  declarations: [
    CabsandTake_5Page,
  ],
  imports: [
    IonicPageModule.forChild(CabsandTake_5Page),
  ],
})
export class CabsandTake_5PageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-take-5/cabsand-take-5.module.ts